import { LenisOptions } from '@studio-freight/lenis'
import { colorsVars } from './config/colors'

const config = {
  debug: {
    sectionBuilder: false,
    routes: false,
    lenis: false,
    cursor: false
  },
  url: process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:9852',
  forms: {
    projectId:
      process.env.NEXT_PUBLIC_FORMSPREE_PROJECT_ID || 'your-project-id',
    deployKey: process.env.NEXT_PUBLIC_FORMSPREE_DEPLOY_KEY || 'key'
  },
  use: {
    lenis: true,
    cursor: false,
    privacy: true
  },
  breakpoints: {
    mobile: 640,
    tablet: 1024
  },
  media: {
    sm: '(min-width: 40rem)',
    md: '(min-width: 48rem)',
    lg: '(min-width: 64rem)',
    xl: '(min-width: 80rem)',
    xxl: '(min-width: 96rem)',
    preferSchemaDark: '(prefers-color-scheme: dark)'
  },
  i18n: {
    locales: ['de'] as const,
    defaultLocale: 'de',
    fallbackLocales: ['de'] as const
  },

  animations: {
    lenis: {
      lerp: 0.25
    } as LenisOptions
  },
  colors: colorsVars
}

export const CONFIG = config
export const DEBUG = config.debug
export const MEDIA = config.media
export const USE = config.use
export const I18N = config.i18n
export const COLORS = config.colors
export const URL = config.url
export const FORMS = config.forms
export type Locale = (typeof I18N.locales)[number]
